/**
 * Piki Car Rentals — final approved logo.
 * Locked artwork used exactly as supplied. No CSS filters, no overlays,
 * no recolouring — the source image already contains every intended colour
 * (mountain white/silver, silver fern, gold PIKI, white CAR RENTALS).
 * Scaled proportionally only.
 */
export default function PikiLogo({ className = "h-16 w-auto", title = "Piki Car Rentals" }) {
  return (
    <img
      src="/piki-logo.png"
      alt={title}
      className={`${className} object-contain`}
      draggable={false}
    />
  );
}
